export default __webpack_public_path__ + "static/media/thrissur.99cfc7a5.jpg";